import { DataLayer } from "@sazka/utils/data-layer";

export namespace FsAnalytics {
    // 2.10 How To Play
    export function pushFurrySpinHowToPlay() {
        DataLayer.push({
            page: {
                type: "game.howToPlay",
                kind: "game.howToPlay",
                gameCode: "chlupotockolo",
                gameCodeStrict: "chlupotockolo",
                verticalCode: "kurzovesazky",
                verticalCodeStrict: "kurzovesazky",
            },
            event: "page",
        });
    }

    // DL2.20 Game History Popup
    export function pushFurrySpinGameHistoryPopup() {
        DataLayer.push({
            page: {
                type: "game.history",
                kind: "game.history",
                gameCode: "chlupotockolo",
                gameCodeStrict: "chlupotockolo",
                verticalCode: "kurzovesazky",
                verticalCodeStrict: "kurzovesazky",
            },
            event: "page",
        });
    }

    // DL2.25 Draw Info Popup
    export function pushFurrySpinDrawInfoPopup() {
        DataLayer.push({
            page: {
                type: "game.drawInfo",
                kind: "game.drawInfo",
                gameCode: "chlupotockolo",
                gameCodeStrict: "chlupotockolo",
                verticalCode: "kurzovesazky",
                verticalCodeStrict: "kurzovesazky",
            },
            event: "page",
        });
    }

    // DL2.30 Game Detail
    export function pushFurrySpinGameDetail() {
        DataLayer.push({
            page: {
                type: "game.detail",
                kind: "game.detail",
                gameCode: "chlupotockolo",
                gameCodeStrict: "chlupotockolo",
                verticalCode: "kurzovesazky",
                verticalCodeStrict: "kurzovesazky",
            },
            event: "page",
        });
    }

    // DL2.35 Impress Coins
    export function pushFurrySpinImpressCoins(coins: string) {
        DataLayer.push({
            event: "action.impressCoins.wheel",
            action: {
                impressCoins: {
                    label: "chlupotockolo",
                    eventProperty1: coins,
                },
            },
        });
    }

    // DL2.40 Game Error
    export function pushFurrySpinGameError() {
        DataLayer.push({
            page: {
                type: "game.error",
                kind: "game.error",
                gameCode: "chlupotockolo",
                gameCodeStrict: "chlupotockolo",
                verticalCode: "kurzovesazky",
                verticalCodeStrict: "kurzovesazky",
            },
            event: "page",
        });
    }

    // DL2.60 Game Not Logged In
    export function pushFurrySpinGameNotLoggedIn() {
        DataLayer.push({
            page: {
                type: "game.notLoggedIn",
                kind: "game.notLoggedIn",
                gameCode: "chlupotockolo",
                gameCodeStrict: "chlupotockolo",
                verticalCode: "kurzovesazky",
                verticalCodeStrict: "kurzovesazky",
            },
            event: "page",
        });
    }

    // DL3.00 Navigation click
    export function pushFurrySpinNavigationClick(label: string) {
        DataLayer.pushInstant({
            event: "action.click.navigation",
            action: {
                click: {
                    label: label?.toLowerCase(),
                    eventProperty1: "sub",
                },
            },
        });
    }

    // DL3.10 Successful spin
    export function pushFurrySpinSuccessfulSpin() {
        DataLayer.push({
            event: "action.spinSuccess.wheel",
            action: {
                spinSuccess: {
                    label: "chlupotockolo",
                },
            },
        });
    }

    // DL3.20 Spin error
    export function pushFurrySpinSpinError(errorMessage: string) {
        DataLayer.push({
            event: "action.spinError.wheel",
            action: {
                spinError: {
                    label: "chlupotockolo",
                    eventProperty1: errorMessage,
                },
            },
        });
    }

    // DL3.50 Win Prize
    export function pushFurrySpinOpenWinModal(prizeWon: string) {
        DataLayer.push({
            event: "action.win.wheel",
            action: {
                win: {
                    label: "chlupotockolo",
                    eventProperty1: prizeWon,
                },
            },
        });
    }

    // DL3.51 Claim Win
    export function pushFurrySpinClaimWin(prizeWon: string) {
        DataLayer.push({
            event: "action.click.wheel",
            action: {
                click: {
                    label: "chlupotockolo",
                    eventProperty1: "claim-win",
                    eventProperty2: prizeWon,
                },
            },
        });
    }

    // DL3.52 Close Win Modal
    export function pushFurrySpinCloseWinModal(prizeWon: string) {
        DataLayer.push({
            event: "action.click.wheel",
            action: {
                click: {
                    label: "chlupotockolo",
                    eventProperty1: "close-win",
                    eventProperty2: prizeWon,
                },
            },
        });
    }

    // DL3.60 Open Task
    export function pushFurrySpinOpenTask(index: number, taskType: string, points: number) {
        DataLayer.push({
            event: "action.openTask.wheel",
            action: {
                openTask: {
                    label: "chlupotockolo",
                    eventProperty1: (index + 1).toString(),
                    eventProperty2: taskType,
                    eventProperty3: points.toString(),
                },
            },
        });
    }

    // DL4.30 Chlupotoc banner impression
    export function pushFurrySpinBannerImpression(creative: string) {
        DataLayer.push({
            event: "action.impress.promos",
            action: {
                impress: {
                    promos: [
                        {
                            id: "chlupotoc.ticketBanner",
                            name: "chlupotoc.ticketBanner",
                            creative: creative,
                            position: "top",
                        },
                    ],
                },
            },
        });
    }

    // DL4.31 Chlupotoc banner click
    export function pushFurrySpinBannerClick(creative: string) {
        DataLayer.push({
            event: "action.show.promos",
            action: {
                show: {
                    promos: [
                        {
                            id: "chlupotoc.ticketBanner",
                            name: "chlupotoc.ticketBanner",
                            creative: creative,
                            position: "top",
                        },
                    ],
                },
            },
        });
    }
}
